import React from "react";
import { Checkbox, FormGroup, FormControlLabel } from '@material-ui/core';

export default function InputCheckBox(props) {

    return (
        <>
            <FormGroup>
                {
                    props.label ?
                        <FormControlLabel control={
                            <Checkbox
                                id={props.id}
                                checked={props.checked || false}
                                onChange={(e) => {
                                    props.onChange(e.target.checked)
                                }}
                            />
                        }
                            label={props.label} /> :
                        <Checkbox
                            id={props.id}
                            checked={props.checked || false}
                            onChange={(e) => {
                                props.onChange(e.target.checked)
                            }}
                        />

                }
            </FormGroup>
        </>
    )
}